document.addEventListener('DOMContentLoaded', () => {
    
    $('.operation-item').click(function() {
        var handle = $(this).attr('handle')
        $('.operation-item').removeClass('selected')
        $('.operation-text').removeClass('active')
        $(this).addClass('selected')

        $('.operation-text').each(function() {
            var content = $(this).attr('handle')

            if (handle === content) {
                $(this).addClass('active')
            }
        })
    })

    $('.operation-text a').attr('target', '_self')

});